import { v1Api, authApi } from '@/plugins/axios'

export interface SignInResponse {
  access_token: string
  token_type: string
}

export const getMe = async () => {
  const response = await v1Api.get('/private/user/me').catch((error: unknown) => {
    console.log('Failed to get the current user:', error)
    return undefined
  })
  return response?.data
}

export const internalSignIn = async (data: URLSearchParams) => {
  const response = await authApi.post<SignInResponse>('signin', data, { withCredentials: true }).catch((error) => {
    console.log('Failed to SignIn:', error)
    return undefined
  })
  return response?.data
}

export const signOut = async (accessToken: string) => {
  await authApi
    .get('sign-out', {
      headers: {
        Authorization: accessToken,
      },
      withCredentials: true,
    })
    .catch((error) => {
      console.log('Failed to SignOut:', error)
      return undefined
    })
}
